module.exports = __webpack_public_path__ + "img/hr-red-croton-12.4a768a64.png";